import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "332",
  height: "155",
  fill: "none",
  viewBox: "0 0 332 155"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M.5 68.1V17.8h17.2v9.6h.5q1.5-4.65 5.4-7.5c2.5-1.8 5.6-2.8 9-2.8s6.6.9 9.1 2.8c2.6 1.9 4.1 4.3 4.6 7.4h.5c.9-3.1 2.7-5.6 5.4-7.4 2.8-1.9 6-2.8 9.8-2.8s8.7 1.6 11.7 4.7 4.5 7.2 4.5 12.4v34H60.1V38.8c0-2.2-.6-3.9-1.7-5.2s-2.6-1.9-4.5-1.9-3.3.6-4.4 1.9c-1.1 1.2-1.6 3-1.6 5.2v29.4H30.6V38.8c0-2.2-.6-3.9-1.7-5.2s-2.6-1.9-4.5-1.9-2.3.3-3.2.9-1.6 1.4-2.1 2.5c-.5 1-.7 2.3-.7 3.8v29.4H.5z",
      class: "cls-2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FDBC04",
      d: "M85.4 52.3h15.8v15.8H85.4z",
      class: "cls-1"
    }, null, -1)
  ]))]))
}
export default { render: render }